import React, { useState } from 'react'

export const OrderPriceContext = React.createContext()

export function OrderPriceContextProvider (props) {
  const [price, setPrice] = useState(0) // 当前已经点的食物的总价格
  const [payPrice, setPayPrice] = useState(0) // 当前已经点的食物需要支付的总价格
  const [yyPrice, setYyPrice] = useState(0) // 营养餐需要付的钱，只是计算用于显示
  const [xgPrice, setXgPrice] = useState(0) // 小锅菜需要付的钱，只是计算用于显示
  const [isYyPot, setIsYyPot] = useState(false) // 当前的餐次中营养餐是否包伙制
  const [isXgPot, setIsXgPot] = useState(false) // 当前的餐次中小锅菜是否包伙制
  return (
    <OrderPriceContext.Provider
      value={{
        price: price,
        setPrice: setPrice,
        payPrice: payPrice,
        setPayPrice: setPayPrice,
        yyPrice: yyPrice,
        setYyPrice: setYyPrice,
        xgPrice: xgPrice,
        setXgPrice: setXgPrice,
        isYyPot: isYyPot,
        setIsYyPot: setIsYyPot,
        isXgPot: isXgPot,
        setIsXgPot: setIsXgPot
      }}
    >
      {props.children}
    </OrderPriceContext.Provider>
  )
}
